import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { db, collection, query, orderBy, where, limit, getDocs } from "../firebaseConfig";

const KanbanJobNumber = ({ newPostJobJobNumber, setNewPostJobJobNumber }) => {
  const [assignJobNumberText, setAssignJobNumberText] =
    useState("Assign Job Number");

  const [assignJobNumberDisabled, setAssignJobNumberDisabled] = useState(false);

  useEffect(() => {
    if (newPostJobJobNumber) {
      setAssignJobNumberDisabled(true);
    } else {
      setAssignJobNumberDisabled(false);
    }
  }, [newPostJobJobNumber, setAssignJobNumberDisabled]);

  const getLatestJobNumber = async (jobYear) => {
    try {
      const jobDataQuery = await getDocs(
        query(
          collection(db, "JobData"),
          orderBy("jobNumber", "desc"),
          where("jobNumber", ">=", 0),
          where("year", "==", jobYear),
          limit(20)
        )
      );

      const year = jobYear.toString().substr(-2);
      let newNum = "000";

      if (jobDataQuery.docs.length > 0) {
        let theDoc;
        for (let i = 0; i < jobDataQuery.docs.length; i++) {
          if (jobDataQuery.docs[i].data().client === "Morrissey Media") {
            continue;
          } else if (jobDataQuery.docs[i].data().jobNumber) {
            if (
              jobDataQuery.docs[i].data().jobNumber.toString().substr(0, 2) ===
              year
            ) {
              theDoc = jobDataQuery.docs[i];
              break;
            }
          }
        }
        if (theDoc) {
          newNum = parseInt(theDoc.data().jobNumber.toString().substr(2)) + 1;
        }
      }

      function padInt(value, padding) {
        let zeroes = new Array(padding + 1).join("0");
        return (zeroes + value).slice(-padding);
      }

      let newFullNum;
      if (newNum > 999) {
        newFullNum = parseInt(`${year}${padInt(newNum, 4)}`);
      } else {
        newFullNum = parseInt(`${year}${padInt(newNum, 3)}`);
      }

      return { jobNumber: newFullNum };
    } catch (error) {
      console.error("Error getting latest job number:", error);
      throw error;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        marginTop: 15,
      }}
    >
      <TextField
        fullWidth
        label="Job Number"
        value={newPostJobJobNumber || ""}
        error={newPostJobJobNumber ? false : true}
        onChange={(e) => {
          setNewPostJobJobNumber(parseInt(e.target.value));
        }}
        variant="filled"
        InputProps={{ disableUnderline: true }}
        sx={{ marginRight: 0, width: "100%" }}
      />
      <Button
        variant="outlined"
        style={{ height: 50, width: 268 }}
        sx={{
          marginLeft: 0,
          padding: 0,
          fontSize: "0.9em",
        }}
        disabled={assignJobNumberDisabled}
        onClick={async () => {
          try {
            const jobYear = new Date().getFullYear();
            setAssignJobNumberText(<CircularProgress size={35} />);
            const result = await getLatestJobNumber(jobYear);
            setNewPostJobJobNumber(parseInt(result.jobNumber));
            setAssignJobNumberText("Assign Job Number");
          } catch (error) {
            console.error("Error assigning job number:", error);
            setAssignJobNumberText("Error - Try Again");
            setTimeout(() => {
              setAssignJobNumberText("Assign Job Number");
            }, 3000);
          }
        }}
      >
        {assignJobNumberText}
      </Button>
    </div>
  );
};

export default KanbanJobNumber;
